import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const StyledLink = styled(Link)`
  ${props => props.withDecoration ? '' : `
    text-decoration: none;
  `}
  
  font-size: ${props => props.theme.font.size.sm};
  color: ${props => props.theme.color.black1};
  font-family: ${props => props.theme.font.family.medium};

  @media screen and (min-width: 1100px) {
  }
`